import React from 'react'
import { TabList as ChakraTabList, TabListProps } from '@chakra-ui/react'

export const TabList: React.FC<
  Pick<TabListProps, 'as' | 'sx' | 'children'>
> = props => <ChakraTabList {...props} />
